class Conditional {
    constructor() {
        this.element = null;
        this.fieldIds = null;
    }

    init(element) {
        this.element = element;
        this.fieldIds = this.element.dataset.conditionfields.split(',');

        if (!this.element) {
            return;
        }

        this.initEventListeners(element);
        this.toggleFields();
    }

    initEventListeners(element) {
        element.addEventListener('change', this.toggleFields.bind(this));
    }

    isConditionField() {
        const conditionFieldIds = this.element.dataset.condition.split(',').map((condition) => condition.trim());
        return conditionFieldIds.indexOf(this.element.id) > -1;
    }

    toggleFields() {
        this.fieldIds.forEach((fieldId) => {
            const fieldElement = document.getElementById(fieldId.trim());

            if (fieldElement) {
                const fieldControl = fieldElement.querySelector('[data-control]');

                if (this.element.checked && this.isConditionField()) {
                    fieldElement.hidden = false;

                    if (!!fieldControl) {
                        fieldControl.disabled = false;
                        fieldControl.required = fieldControl.dataset.conditionrequired === 'true';
                    }
                } else {
                    fieldElement.hidden = true;

                    if (!!fieldControl) {
                        fieldControl.disabled = true;
                        fieldControl.required = false;
                    }
                }
            }
        });
    }
}

export default Conditional;
